import type { Property } from './property-types'

interface ConfirmPropertyStatusDialogProps {
  property: Property
  isPending: boolean
  error: string | null
  onCancel: () => void
  onConfirm: () => void
}

export function ConfirmPropertyStatusDialog({ property, isPending, error, onCancel, onConfirm }: ConfirmPropertyStatusDialogProps) {
  const isRestore = property.status === 'archived'
  return (
    <div className="dialog-backdrop">
      <section className="confirm-dialog" role="alertdialog" aria-modal="true" aria-labelledby="confirm-status-title" aria-describedby="confirm-status-description">
        <p className="eyebrow">Confirm action</p>
        <h2 id="confirm-status-title">{isRestore ? 'Restore property?' : 'Archive property?'}</h2>
        <p id="confirm-status-description">
          {isRestore
            ? `${property.name} will return to Draft and appear in the active portfolio.`
            : `${property.name} will be hidden from the default portfolio view. Its data will not be deleted.`}
        </p>
        {error && <p className="form-error" role="alert">{error}</p>}
        <div className="dialog-actions">
          <button className="secondary-button" type="button" onClick={onCancel} disabled={isPending}>Cancel</button>
          <button className={isRestore ? '' : 'danger-button'} type="button" onClick={onConfirm} disabled={isPending}>
            {isPending ? 'Saving…' : isRestore ? 'Restore property' : 'Archive property'}
          </button>
        </div>
      </section>
    </div>
  )
}
